import React from 'react';

import GotoAccountHotkey from './goto-account-settings';
import GotoCarrierHotkey from './goto-carrier-fulfullment-settings';
import GotoCustomersHotkey from './goto-customers';
import GotoOrdersHotkey from './goto-orders';
import GotoPrintHotkey from './goto-print-setup-settings';
import GotoProductsHotkey from './goto-products-inventory';
import GotoProductsInventoryHotkey from './goto-products';
import GotoShipmentsBatchesHotkey from './goto-shipments-batches';
import GotoShipmentsEodHotkey from './goto-shipments-eod';
import GotoShipmentsFulfillmentsHotkey from './goto-shipments-fulfillments';
import GotoShipmentsPickupHotkey from './goto-shipments-pickup';
import GotoShipmentsReturnsHotkey from './goto-shipments-returns';
import GotoShipmentsShipmentsHotkey from './goto-shipments';
import GotoShipstationHotkey from './goto-shipstation-connect-settings';
import GotoStoreHotkey from './goto-store-setup-settings';
import GotoSubscriptionHotkey from './goto-subscription-settings';

const navHotkeys = [
  GotoAccountHotkey,
  GotoCarrierHotkey,
  GotoCustomersHotkey,
  GotoOrdersHotkey,
  GotoPrintHotkey,
  GotoProductsHotkey,
  GotoProductsInventoryHotkey,
  GotoShipmentsBatchesHotkey,
  GotoShipmentsEodHotkey,
  GotoShipmentsFulfillmentsHotkey,
  GotoShipmentsPickupHotkey,
  GotoShipmentsReturnsHotkey,
  GotoShipmentsShipmentsHotkey,
  GotoShipstationHotkey,
  GotoStoreHotkey,
  GotoSubscriptionHotkey,
];

const NavigationHotkeys = ({ children, ...props }) => {
  return navHotkeys.reduce((acc, Hotkey) => <Hotkey {...props}>{acc}</Hotkey>, children);
};

export default NavigationHotkeys;
